
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import VideoFinishingLanding from '@/components/videos/finishing/VideoFinishingLanding';
import { videoFinishingLandingProps } from '@/utils/videoFinishingLandingProps';
export default VideoFinishingLanding;
const getStaticProps = async () => ({
    props: videoFinishingLandingProps('upscale'),
});

    async function __Next_Translate__getStaticProps__1a15314ecae__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-video-upscaler',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a15314ecae__ as getStaticProps }
  